import React from 'react'
import AdnCard from '../common/adnCard/AdnCard'
import AdnPageTitle from '../common/adnPageTitle/AdnPageTitle'
import AdnTable from '../common/adnTable/AdnTable'
import { Col, Modal, Row, Space, Form } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import AdnInput from '../common/adnInput/AdnInput';
import AdnAddButton from '../common/adnAddButton/AdnAddButton';
import { NameValidation } from './CompanyValidations';
import AdnYesNoModal from '../common/adnYesNoModal/AdnYesNoModal'
import adnYesNoModal from '../common/adnYesNoModal/AdnYesNoModal';

function CompanyPageForm({ loading, companyData, visible, setVisible, event, submitCompany, setEvent, setCompanyHandler, deleteRecord }) {
    const [form] = Form.useForm();
    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            width: '30%',
            editable: true,
            sorter: (a, b) => a.name.localeCompare(b.name),
        },

        {
            title: "Actions",
            key: "action",
            render: (record) => (
                <Space size="middle">
                    <EditOutlined
                        style={{ color: "black" }}
                        onClick={() => {
                            setEvent("edit")
                            setVisible(true);
                            form.setFieldsValue(record);
                            setCompanyHandler(record);
                        }}
                    />

                    <DeleteOutlined
                        style={{ color: "red" }}
                        onClick={() => {
                            adnYesNoModal(() => deleteRecord(record.id))
                        }}
                    />
                </Space>
            ),
            width: "10%",
        },
    ];

    return <>
        <AdnPageTitle title={"Companies "} />
        <AdnCard loading={loading}>

            <AdnAddButton handleClick={() => { setEvent("add"); setVisible(true); form.setFieldsValue({ name: "" }); }} />

            <Row>
                <Col span={24}>
                    <AdnTable data={companyData} columns={columns} pagination={false} totalRecords={companyData.length()} />
                </Col>
            </Row>

        </AdnCard>

        <Modal
            title={(event == "add") ? "New Company" : "Edit Company"}
            open={visible}
            onOk={form.submit}
            cancelText={"Back"}
            okText={"Save"}
            onCancel={() => { setVisible(false); }}>

            <Form form={form} name="form_in_modal" layout="vertical" onFinish={submitCompany}>

                <AdnInput name={"name"} label={"Name"} placeholder={"Insert the name"} rules={NameValidation} />

            </Form>

        </Modal>
    </>

}

export default CompanyPageForm